import React, { useEffect, useState } from "react";

import { useAuthStore } from "../store/store";

function User() {
  const { getAllUser, userUpdate, user } = useAuthStore();
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [updatedUserData, setUpdatedUserData] = useState({});

  useEffect(() => {
    if (user?.accountType !== "admin") {
      window.location.href = "/dashboard";
    }
    fetchUsers();
  }, []);

  // Fetch all users
  const fetchUsers = async () => {
    try {
      const response = await getAllUser();
      setUsers(response.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  // Select a user to edit
  const handleSelectUser = (user) => {
    setSelectedUser(user);
    setUpdatedUserData(user);
    setIsEditing(false);
  };

  // Handle input change in edit mode
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedUserData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Save edited user data
  const handleSave = async () => {
    try {
      const response = await userUpdate(updatedUserData);
      if (response?.data) {
        alert("Plan updated successfully!");
        // console.log(response.data);
        // setPlanData(response.data);

        setUsers(
          users.map((u) => (u._id === selectedUser._id ? updatedUserData : u))
        );
        setSelectedUser(updatedUserData);
        setIsEditing(false);
        alert("User data updated successfully!");
      }
    } catch (error) {
      console.error("Error updating user data:", error);
    }
  };

  return (
    <div className="container mx-auto mt-10 p-6 bg-white shadow-lg rounded-lg max-w-4xl">
      <h2 className="text-3xl font-bold text-gray-800 mb-6">User Management</h2>

      {/* User Table */}
      <table className="w-full border-collapse border border-gray-200 mb-6">
        <thead>
          <tr className="bg-gray-100">
            <th className="border px-4 py-2">Profile</th>
            <th className="border px-4 py-2">Name</th>
            <th className="border px-4 py-2">Email</th>
            <th className="border px-4 py-2">Account Type</th>
            <th className="border px-4 py-2">Action</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user._id} className="hover:bg-gray-50">
              <td className="border px-4 py-2">
                <img
                  src={user.profilePicture}
                  alt="Profile"
                  className="w-10 h-10 rounded-full"
                />
              </td>
              <td className="border px-4 py-2">
                {user.firstName} {user.lastName}
              </td>
              <td className="border px-4 py-2">{user.email}</td>
              <td className="border px-4 py-2">{user.accountType}</td>
              <td className="border px-4 py-2">
                <button
                  onClick={() => handleSelectUser(user)}
                  className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-700"
                >
                  Edit
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* User Edit Section */}
      {selectedUser && (
        <div className="mt-6 p-4 bg-gray-50 rounded-lg shadow">
          <h3 className="text-2xl font-bold text-gray-800 mb-4">Edit User</h3>

          <table className="w-full border-collapse border border-gray-200">
            <tbody>
              <tr>
                <td className="border px-4 py-2 font-semibold">
                  Profile Picture
                </td>
                <td className="border px-4 py-2">
                  <img
                    src={selectedUser.profilePicture}
                    alt="Profile"
                    className="w-16 h-16 rounded-full"
                  />
                </td>
              </tr>
              {Object.entries(selectedUser).map(([key, value]) =>
                key !== "password" &&
                key !== "__v" &&
                key !== "profilePicture" ? (
                  <tr key={key}>
                    <td className="border px-4 py-2 font-semibold">{key}</td>
                    <td className="border px-4 py-2">
                      {isEditing ? (
                        <input
                          type="text"
                          name={key}
                          value={updatedUserData[key] || ""}
                          onChange={handleChange}
                          className="w-full border rounded px-2 py-1"
                        />
                      ) : (
                        value.toString()
                      )}
                    </td>
                  </tr>
                ) : null
              )}
            </tbody>
          </table>

          <div className="flex gap-4 mt-4">
            {isEditing ? (
              <button
                onClick={handleSave}
                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
              >
                Save
              </button>
            ) : (
              <button
                onClick={() => setIsEditing(true)}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                Edit
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default User;
